import { z } from 'zod';
import type { Role } from '../permissions.js';

/** The authenticated principal, shared by server (req.user) and client (session state). */
export interface AuthUser {
  id: string;
  username: string;
  displayName: string;
  role: Role;
  /** Set for external clinic accounts. */
  clinicId?: string | null;
  /** Set for per-case patient accounts. */
  caseId?: string | null;
  /** Effective permission keys for this user (defaults + overrides, super-admin => all). */
  permissions: string[];
}

export const loginSchema = z.object({
  username: z.string().min(1).max(120),
  password: z.string().min(1).max(200),
});
export type LoginRequest = z.infer<typeof loginSchema>;

export interface MeResponse {
  user: AuthUser;
}
